webpackJsonp([35783957827783],{

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n        right: 20px;\n        left: 20px;\n        bottom: 20px;\n    "], ["\n        right: 20px;\n        left: 20px;\n        bottom: 20px;\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n        width: 100%;\n        padding: 3rem;\n    "], ["\n        width: 100%;\n        padding: 3rem;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n        font-size: 18px;\n        line-height: 24px;\n    "], ["\n        font-size: 18px;\n        line-height: 24px;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(89);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _polished = __webpack_require__(12);
	
	var _reactDynamicForm = __webpack_require__(203);
	
	var _reactDynamicForm2 = _interopRequireDefault(_reactDynamicForm);
	
	var _components = __webpack_require__(11);
	
	var _settings = __webpack_require__(32);
	
	var _utils = __webpack_require__(73);
	
	var _global = __webpack_require__(5);
	
	var _type = __webpack_require__(10);
	
	var _utils2 = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _validators = __webpack_require__(141);
	
	var _constants = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POPUP_SESSION_KEY = 'homeNewsletterPopupSeen';
	var POPUP_SCROLL_THRESHOLD = 0.5;
	
	var ArrowRightIcon = function ArrowRightIcon() {
	    return _react2.default.createElement(
	        "svg",
	        { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M5 12H19M13 6L19 12L13 18", stroke: "#4D402E", strokeLinecap: "square", strokeLinejoin: "round" })
	    );
	};
	
	var Home = function (_Component) {
	    _inherits(Home, _Component);
	
	    function Home(props) {
	        _classCallCheck(this, Home);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            acf: null,
	            popupActive: false,
	            newsletterComplete: false,
	            newsletterError: null
	        };
	
	        _this.componentWillMount = function () {
	            _this.props.fetchSettings();
	            var data = _this.props.data.wordpressHome;
	            _this.setState({
	                acf: JSON.parse(data.acf_json)
	            });
	        };
	
	        _this.componentDidMount = function () {
	            var seen = false;
	            try {
	                seen = !!sessionStorage.getItem(POPUP_SESSION_KEY);
	            } catch (e) {}
	            if (seen) return;
	
	            _this.scrollTicking = false;
	            window.addEventListener('scroll', _this.onScroll, { passive: true });
	        };
	
	        _this.componentWillUnmount = function () {
	            window.removeEventListener('scroll', _this.onScroll);
	        };
	
	        _this.onScroll = function () {
	            if (_this.scrollTicking) return;
	            _this.scrollTicking = true;
	            window.requestAnimationFrame(_this.checkScrollThreshold);
	        };
	
	        _this.checkScrollThreshold = function () {
	            _this.scrollTicking = false;
	            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
	            var progress = docHeight > 0 ? scrollTop / docHeight : 0;
	
	            if (progress >= POPUP_SCROLL_THRESHOLD) {
	                _this.showPopup();
	            }
	        };
	
	        _this.showPopup = function () {
	            try {
	                sessionStorage.setItem(POPUP_SESSION_KEY, '1');
	            } catch (e) {}
	            window.removeEventListener('scroll', _this.onScroll);
	            _this.setState({ popupActive: true });
	        };
	
	        _this.dismissPopup = function () {
	            _this.setState({ popupActive: false });
	        };
	
	        _this.handleNewsletterSubmit = function (fields, resetForm) {
	            var emailValue = fields['email'].value;
	
	            var body = new URLSearchParams();
	            body.append('email', emailValue);
	            body.append('source', 'homepage_popup');
	
	            fetch(_constants.NEWSLETTER_WEBHOOK_URL, {
	                method: 'POST',
	                body: body
	            }).then(function (r) {
	                if (r.ok) {
	                    _this.setState({ newsletterComplete: true, newsletterError: null });
	                    resetForm();
	                    setTimeout(_this.dismissPopup, 2500);
	                } else {
	                    _this.setState({ newsletterError: 'Something went wrong. Please try again.' });
	                }
	            }).catch(function () {
	                _this.setState({ newsletterError: 'Something went wrong. Please try again.' });
	            });
	        };
	
	        _this.renderSections = function () {
	            var acf = _this.state.acf;
	
	            if (!acf || !acf.sections) return null;
	
	            // Contact + subscribe now live in the global FooterBlock, so filter
	            // them out of the homepage sections to avoid duplicate content.
	            var HIDDEN_LAYOUTS = ['contact', 'sign_up'];
	
	            return acf.sections.map(function (section, i) {
	                if (!section.display_section || !section.blocks) return null;
	
	                var visibleBlocks = section.blocks.filter(function (b) {
	                    return HIDDEN_LAYOUTS.indexOf(b.acf_fc_layout) === -1;
	                });
	                if (visibleBlocks.length === 0) return null;
	
	                return _react2.default.createElement(_components.Section, {
	                    key: i,
	                    blocks: visibleBlocks,
	                    section: section
	                });
	            });
	        };
	
	        _this.renderPopup = function () {
	            var _this$state = _this.state,
	                popupActive = _this$state.popupActive,
	                newsletterComplete = _this$state.newsletterComplete,
	                newsletterError = _this$state.newsletterError;
	
	
	            var newsletterFields = {
	                fields: [{
	                    type: 'text',
	                    name: 'email',
	                    label: 'Email Address',
	                    validator: _validators.email,
	                    errorMessage: 'Please enter a valid email address'
	                }]
	            };
	
	            return _react2.default.createElement(
	                Popup,
	                { active: popupActive },
	                _react2.default.createElement(
	                    PopupCard,
	                    null,
	                    _react2.default.createElement(
	                        PopupClose,
	                        { onClick: _this.dismissPopup, "aria-label": "Close" },
	                        "\xD7"
	                    ),
	                    newsletterComplete ? _react2.default.createElement(
	                        PopupThanks,
	                        null,
	                        "Thanks \u2014 you're subscribed."
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            PopupHeading,
	                            null,
	                            "Stay Connected"
	                        ),
	                        _react2.default.createElement(
	                            PopupCopy,
	                            null,
	                            "Subscribe to receive occasional updates from the studio, including recent projects, publications and news from Paul Conrad Architects."
	                        ),
	                        _react2.default.createElement(
	                            PopupFormRow,
	                            null,
	                            _react2.default.createElement(
	                                PopupFormInputWrap,
	                                null,
	                                _react2.default.createElement(_reactDynamicForm2.default, {
	                                    ref: _this.newsletterForm,
	                                    data: newsletterFields,
	                                    styles: popupFormStyles,
	                                    renderInput: _react2.default.createElement(_components.Input, null),
	                                    renderSubmit: false,
	                                    onSubmit: _this.handleNewsletterSubmit,
	                                    moveToInvalidField: false
	                                })
	                            ),
	                            _react2.default.createElement(
	                                PopupArrow,
	                                {
	                                    onClick: function onClick() {
	                                        _this.newsletterForm.current && _this.newsletterForm.current.handleSubmit();
	                                    },
	                                    "aria-label": "Subscribe"
	                                },
	                                _react2.default.createElement(ArrowRightIcon, null)
	                            )
	                        ),
	                        newsletterError && _react2.default.createElement(
	                            PopupError,
	                            null,
	                            newsletterError
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.newsletterForm = _react2.default.createRef();
	        return _this;
	    }
	
	    Home.prototype.render = function render() {
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                _gatsbyPluginPageTransitions2.default,
	                _utils.pageTransitionProps,
	                _react2.default.createElement(
	                    Wrapper,
	                    null,
	                    this.renderSections()
	                )
	            ),
	            this.renderPopup()
	        );
	    };
	
	    return Home;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	    displayName: "pages__Wrapper",
	    componentId: "k5b7gm-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;"]);
	
	// Homepage newsletter popup
	
	var Popup = _styledComponents2.default.div.withConfig({
	    displayName: "pages__Popup",
	    componentId: "k5b7gm-1"
	})(["position:fixed;right:3rem;bottom:3rem;z-index:12;transition:opacity 0.4s ease,transform 0.4s ease;opacity:", ";transform:", ";pointer-events:", ";", " *{text-indent:0 !important;}"], function (props) {
	    return props.active ? 1 : 0;
	}, function (props) {
	    return props.active ? 'translateY(0)' : 'translateY(20px)';
	}, function (props) {
	    return props.active ? 'auto' : 'none';
	}, _utils2.media.phone(_templateObject));
	
	var PopupCard = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupCard",
	    componentId: "k5b7gm-2"
	})(["position:relative;width:380px;max-width:100%;background:#EDEDEB;padding:4rem;box-sizing:border-box;box-shadow:0 8px 24px ", ";", ""], (0, _polished.rgba)('#000000', 0.08), _utils2.media.phone(_templateObject2));
	
	var PopupClose = _styledComponents2.default.button.withConfig({
	    displayName: "pages__PopupClose",
	    componentId: "k5b7gm-3"
	})(["position:absolute;top:12px;right:12px;background:transparent;border:0;padding:4px 8px;font-size:24px;line-height:1;color:", ";cursor:pointer;", ";"], _colors.grey, _global.hoverState);
	
	var PopupHeading = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupHeading",
	    componentId: "k5b7gm-4"
	})(["font-family:'Scto';font-weight:300;font-size:22px;line-height:28px;color:", ";margin-bottom:2rem;", ""], _colors.grey, _utils2.media.laptop(_templateObject3));
	
	var PopupCopy = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupCopy",
	    componentId: "k5b7gm-5"
	})(["", ";color:", ";margin-bottom:3rem;"], _type.paragraph, _colors.grey);
	
	var PopupFormRow = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupFormRow",
	    componentId: "k5b7gm-6"
	})(["display:flex;align-items:center;position:relative;border-bottom:1px solid ", ";.dynamic-field{margin-bottom:0 !important;}.field-wrapper{border-bottom:0 !important;margin-bottom:0 !important;}"], (0, _polished.rgba)('#595850', 0.4));
	
	var PopupFormInputWrap = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupFormInputWrap",
	    componentId: "k5b7gm-7"
	})(["flex:1;min-width:0;"]);
	
	var PopupArrow = _styledComponents2.default.button.withConfig({
	    displayName: "pages__PopupArrow",
	    componentId: "k5b7gm-8"
	})(["background:transparent;border:0;padding:0;margin-left:16px;display:flex;align-items:center;cursor:pointer;svg{display:block;}&:hover{opacity:0.7;}"]);
	
	var PopupThanks = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupThanks",
	    componentId: "k5b7gm-9"
	})(["", ";color:", ";"], _type.paragraph, _colors.grey);
	
	var PopupError = _styledComponents2.default.div.withConfig({
	    displayName: "pages__PopupError",
	    componentId: "k5b7gm-10"
	})(["", ";color:#F03232;margin-top:12px;"], _type.caption);
	
	var popupFormStyles = (0, _styledComponents.css)([".dynamic-field{margin-bottom:0;.field-wrapper{border-bottom:0;margin-bottom:0;}}"]);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchSettings: function fetchSettings() {
	            dispatch((0, _settings.fetchSettings)());
	        }
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        settings: state.settings.settings
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.encode = encode;
	exports.getParameterByName = getParameterByName;
	exports.getUrlDomain = getUrlDomain;
	exports.rgb = rgb;
	function encode(data) {
	    return Object.keys(data).map(function (key) {
	        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	    }).join("&");
	}
	
	function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	function getUrlDomain() {
	    if (!window.location.origin) {
	        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	    }
	    return window.location.origin;
	}
	
	function rgb(hex) {
	    "use strict";
	
	    if (hex.charAt(0) === '#') {
	        hex = hex.substr(1);
	    }
	    if (hex.length < 2 || hex.length > 6) {
	        return false;
	    }
	    var values = hex.split(''),
	        r,
	        g,
	        b;
	
	    if (hex.length === 2) {
	        r = parseInt(values[0].toString() + values[1].toString(), 16);
	        g = r;
	        b = r;
	    } else if (hex.length === 3) {
	        r = parseInt(values[0].toString() + values[0].toString(), 16);
	        g = parseInt(values[1].toString() + values[1].toString(), 16);
	        b = parseInt(values[2].toString() + values[2].toString(), 16);
	    } else if (hex.length === 6) {
	        r = parseInt(values[0].toString() + values[1].toString(), 16);
	        g = parseInt(values[2].toString() + values[3].toString(), 16);
	        b = parseInt(values[4].toString() + values[5].toString(), 16);
	    } else {
	        return false;
	    }
	    return "rgb(" + r + ", " + g + ", " + b + ")";
	}
	
	var pageTransitionProps = exports.pageTransitionProps = {
	    defaultStyle: {
	        width: '100vw',
	        maxWidth: '100%',
	        transition: 'opacity 500ms ease-out',
	        opacity: 0
	    },
	    transitionStyles: {
	        entering: { opacity: '0' },
	        entered: { opacity: '1' },
	        exiting: { opacity: '0' }
	    }
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8dd11b53b47f7bc12ccd.js